import { renderRequiredRule } from '@/utils/renderRulesForm';

export default (cargoInformation) => ({
  typeOfCargo: [renderRequiredRule('Пожалуйста выберите вид')],
  numberOfIdenticalLoads: [renderRequiredRule('Пожалуйста введите количество')],
  cargoVolume: [renderRequiredRule('Пожалуйста введите объём')],
  cargoWeight: [renderRequiredRule('Пожалуйста введите массу')],
  cargoDimensions: [
    {
      validator: (rule, value, callback) => {
        if ([cargoInformation.sizeOfCargoCylinder.height, cargoInformation.sizeOfCargoCylinder.diameter].some((dimension) => Number(dimension) < 10) && cargoInformation.typeOfCargo === 'Цилиндры') {
          callback(new Error('Каждый габарит минимум 10 см'));
        }
        if ([value.length, value.height, value.width].some((dimension) => Number(dimension) < 10) && cargoInformation.typeOfCargo === 'Стандарт') {
          callback(new Error('Каждый габарит минимум 10 см'));
        }
        if (value.length && value.width && value.height && cargoInformation.typeOfCargo === 'Стандарт') {
          callback();
        }
        if (cargoInformation.sizeOfCargoCylinder.diameter && cargoInformation.sizeOfCargoCylinder.height && cargoInformation.typeOfCargo === 'Цилиндры') {
          callback();
        }
        callback(new Error('Введите габариты'));
      },
      trigger: 'blur',
    },
  ],
  sizeOfCargoCylinder: {
    height: [
      {
        validator: (rule, value, callback) => {
          if (cargoInformation.typeOfCargo === 'Цилиндры' && value === null) {
            callback(new Error('Введите высоту'));
          }
          callback();
        },
        trigger: 'blur',
      },
    ],
    diameter: [
      {
        validator: (rule, value, callback) => {
          if (cargoInformation.typeOfCargo === 'Цилиндры' && value === null) {
            callback(new Error('Введите диаметр'));
          }
          callback();
        },
        trigger: 'blur',
      },
    ],
  },
  additionalPackaging: [],
  typeOfPackaging: [
    {
      validator: (rule, value, callback) => {
        if (cargoInformation.additionalPackaging && !value.length) {
          callback(new Error('Пожалуйста выберите тип'));
        }
        callback();
      },
      trigger: 'blur',
    },
  ],
  natureOfCargo: [],
  cargoCost: [renderRequiredRule('Пожалуйста введите стоимость')],
});
